module.exports = "/images/ruler.svg?87baf7942558903be0ac6133d8a72410";